import type { NextPage } from 'next'
import Link from 'next/link'
import { useRef } from 'react'
import menuItems, { IMenuItem } from '../menus'

interface IProps {
  item: IMenuItem
  index: number
}

const NavMenuItem: NextPage<IProps> = ({ item, index }) => {
  const subMenuRef = useRef<HTMLDivElement>(null);
  return (
    <li
      className='relative flex items-center justify-center flex-1 h-full text-center'
      onMouseOver={() => { subMenuRef.current?.classList.remove('hidden'); }}
      onMouseLeave={() => { subMenuRef.current?.classList.add('hidden'); }}
    >
      <Link href={item.href}>
        <a className='flex items-center justify-center w-full h-full text-white hover:font-medium'>{item.title}</a>
      </Link>
      <div ref={subMenuRef} id={`headerNavSubmenu${index}`} className='absolute hidden top-[64px] left-[0px] w-[300px] z-10 backdrop-blur-sm'>
        {item.subItems && item.subItems.map((subItem, subIndex) => (
          <div key={`subMenu-${subIndex}`} className='flex items-center h-[60px] bg-gg-blue !opacity-[.82] hover:bg-gg-green hover:!opacity-[.92]'>
            <Link href={subItem.href}>
              <a className='flex items-center justify-center w-full h-full px-5 text-white'>
                {subItem.title}
              </a>
            </Link>
          </div>
        ))}
      </div>
    </li>
  )
};

const Component: NextPage = () => {
  return (
    <div className='min-w-[1200px] h-[64px] flex justify-center bg-headerNav-bg'>
      <div className='w-[1200px] min-w-[1200px] max-w-[1200px] flex items-center justify-center'>
        <ul className='flex items-center justify-center w-full h-full'>
          <NavMenuItem item={menuItems[0]} index={0} />
          <div className='text-white cursor-default w-[0px]'>|</div>
          <NavMenuItem item={menuItems[1]} index={1} />
          <div className='text-white cursor-default w-[0px]'>|</div>
          <NavMenuItem item={menuItems[2]} index={2} />
          <div className='text-white cursor-default w-[0px]'>|</div>
          <NavMenuItem item={menuItems[3]} index={3} />
        </ul>
      </div>
    </div>
  )
}

export default Component
